<template>
  <modal 
    name="technical-means-modal"
    class="technical-means-modal modal-without-footer"
    @before-open="handleBeforeOpen"
    transition="fade"
    :adaptive="true"
    :reset="true"
    width="60%"
    height="auto"
    style="z-index: 2011;"
  >
    <div id="modal-header">
      <div class="w-75 d-flex">
        <p>Տեխնիկական միջոցներ</p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 25%"
              @click="$modal.hide('technical-means-modal')" aria-label="Close">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
        </svg>
      </button>
    </div>
    <div id="modal-body">
        <table style=" font-size: 14px; font-family: GHEA grapalat ; 		width: 100%;
								table-layout: fixed;
								border-collapse: collapse;
								page-break-inside: avoid;
								border: 1px solid  black;
								margin: 20px auto;
								padding-bottom: 50px;
								text-align: center;
								margin-bottom: .5rem;
								margin-top: .5rem
				">
            <thead>
            <tr>
                <th style="
                            border: 1px solid  black;
                            border-collapse: collapse;">N</th>
                <th style="
                            border: 1px solid  black;
                            border-collapse: collapse;">Տեխնիկական միջոցի անվանումը</th>
                <th style="
                            border: 1px solid  black;
                            border-collapse: collapse;">Տիպը</th>
                <th style="
                            border: 1px solid  black;
                            border-collapse: collapse;">Տեխնիկական միջոցի մակնիշը, պետհամարանիշը, (եթե առկա է) և արտադրության տարեթիվը</th>
                <th style="
                            border: 1px solid  black;
                            border-collapse: collapse;">Տեխնիկական միջոցի նկատմամբ իրավունքի տեսակը</th>
                <th style="
                            border: 1px solid  black;
                            border-collapse: collapse;"></th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(row, index) in dataRows">
                <td style="
                            border: 1px solid  black;
                            border-collapse: collapse;">
                    {{index + 1 }}
                </td>
                <td style="
                            border: 1px solid  black;
                            border-collapse: collapse;">
                    {{row.name}}
                </td>
                <td style="
                            border: 1px solid  black;
                            border-collapse: collapse;">
                    {{row.type}}
                </td>
                <td style="
                            border: 1px solid  black;
                            border-collapse: collapse;">
                    {{row.mark}}
                </td>
                <td style="
                            border: 1px solid  black;
                            border-collapse: collapse;">
                    {{row.rightType}}
                </td>
                <td style="
                            border: 1px solid  black;
                            border-collapse: collapse;">
                        <button @click="addRow(index)" type="button"
                                class="btn btn-primary"
                                :style="((index !== dataRows.length - 1) || index === 4) && 'opacity: 0;'"
                        >
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
  </modal>
</template>

<script>
  import 'vue-date-pick/dist/vueDatePick.css';

  export default {
    name: 'ProductsDetailsModal',
    components: {  },
    data() {
      return {
        procedure_type: null,
        cpv_type: 'product',
        is_with_model: true,
          dataRows: [
              {
                  name: '',
                  mark: '',
                  type: '',
                  rightType: '',
              }
          ],
      }
    },
    validations: {
      row: {
        firm_name: {  },
        trademark: {  },
        brand: {  },
        manufacturer: {  },
      },
    },
    computed: {
      currentOrganized() {
        return this.$store.getters['organize/currentOrganized']
      },
    },
    methods: {
        addRow(index) {
            this.dataRows.push({
                name: '',
                mark: '',
                type: '',
                rightType: '',
            })
        },
      handleBeforeOpen({params}) {
      },
      save() {
        if(!this.$v.row.$invalid) {
          this.setProductDetails(this.row, this.index);
          this.$modal.hide('technical-means-modal')
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք տեխնիկական բնութագրեր դաշտը, պահպանելու համար!'
          })
        }
      }
    }
  }
</script>
<style scoped>
  @media (max-width: 768px) {
    .technical-means-modal /deep/ .vm--modal #modal-body{
      height: calc(100% - 84px);
    }
  }
  @media (max-width: 345px) {
    .technical-means-modal /deep/ .vm--modal #modal-body{
      height: calc(100% - 109px);
    }
  }
  #modal-body{
    padding-top: 17px;
    padding-bottom: 0px;
  }
  #modal-footer{
    text-align: center;
    padding-bottom: 30px;
  }
  .form-group{
    margin-bottom: 28px;
  }
</style>